import { ReactNode } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useCashierAuth } from '../hooks/useCashierAuth';

type CashierLayoutProps = {
  title: string;
  subtitle?: string;
  backTo?: string;
  children: ReactNode;
};

export default function CashierLayout({ title, subtitle, backTo, children }: CashierLayoutProps) {
  const { cashier, logout } = useCashierAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-stone-50 px-4 py-6 lg:px-10">
      <div className="mx-auto max-w-4xl">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div className="min-w-0">
            {backTo ? (
              <button
                type="button"
                onClick={() => navigate(backTo)}
                className="mb-2 inline-flex items-center gap-1 text-sm font-medium text-stone-600 hover:text-stone-900"
              >
                <ArrowLeft className="h-4 w-4" />
                Back
              </button>
            ) : null}
            <h1 className="text-2xl font-bold text-stone-900">{title}</h1>
            <div className="mt-1 text-sm text-stone-600">
              {cashier?.username ? <span className="font-medium">{cashier.username}</span> : null}
              {subtitle ? (
                <>
                  {cashier?.username ? ' • ' : null}
                  {subtitle}
                </>
              ) : null}
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Link
              to="/"
              className="rounded-lg border border-stone-200 bg-white px-3 py-2 text-sm font-semibold hover:bg-stone-50"
            >
              My shifts
            </Link>
            <button
              type="button"
              className="rounded-lg border border-stone-200 bg-white px-3 py-2 text-sm font-semibold hover:bg-stone-50"
              onClick={() => logout()}
            >
              Sign out
            </button>
          </div>
        </div>
        <div className="mt-6">{children}</div>
      </div>
    </div>
  );
}
